"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _shapes = _interopRequireDefault(require("./shapes"));
var _text = _interopRequireDefault(require("@ux/text"));
var _creditCard = _interopRequireDefault(require("@ux/icon/credit-card"));
var _alert = _interopRequireDefault(require("@ux/icon/alert"));
var _chevronRight = _interopRequireDefault(require("@ux/icon/chevron-right"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/**
 * Renders individual notification list item.
 *
 * @class NotificationListItem
 * @public
 *
 * @returns {React.ReactElement} Notifications
 */

class NotificationListItem extends _react.Component {
  constructor(props) {
    super(props);
    this.renderNotificationLink = this.renderNotificationLink.bind(this);
    this.renderStaticNotification = this.renderStaticNotification.bind(this);
  }

  /**
   * Renders notification with link when link is available.
   *
   * @typedef {Object} Icon Visual indicator type for a credit card or alert icon
   *
   * @params {Object} notification Single notification
   * @params {Object} [notification.eids] Single notification's EID info
   * @params {sting} [notification.eids.click] Single notification click Eid
   * @params {string} notification.content Single notification
   * @params {string} href The link for the notification
   * @params {array} classes List of needed classes
   * @params {Icon} icon Visual indicator type icon
   *
   * @private
   * @returns {React.ReactElement} Individual notification
   */

  renderNotificationLink(notification, href, classes, icon) {
    const {
      content,
      eids
    } = notification;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("a", {
      target: "_blank",
      rel: "noopener noreferrer",
      href: href,
      "data-eid": eids && eids.click,
      className: classes
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "priority-icon"
    }, icon), /*#__PURE__*/_react.default.createElement("div", {
      className: "priority-indicator"
    }), /*#__PURE__*/_react.default.createElement(_text.default.div, {
      className: "notification-content",
      text: content
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: "icon-notification-link"
    }, /*#__PURE__*/_react.default.createElement(_chevronRight.default, null))));
  }

  /**
   * Renders notification with cta and message when cta is available.
   *
   * @typedef {Object} Icon Visual indicator type for a credit card or alert icon
   *
   * @params {Object} notification Single notification
   * @params {Object} [notification.eids] Single notification's EID info
   * @params {sting} [notification.eids.click] Single notification click Eid
   * @params {string} notification.title Title of the notification
   * @params {string} notification.message Sub title for the notification
   * @params {string} cta The cta info for the notification
   * @params {string} cta.text The text for the notification cta button
   * @params {string} cta.url The link for the notification cta button
   * @params {string} section a piece of text for a section heading
   * @params {array} classes List of needed classes
   *
   * @private
   * @returns {React.ReactElement} Individual notification
   */

  renderRADNotification(notification, classes) {
    var _ctaURL, _ctaURL$match;
    const {
      title,
      message,
      eids,
      cta,
      section
    } = notification;
    const hasSection = !!section;
    let ctaURL = cta.url;
    if (!((_ctaURL = ctaURL) !== null && _ctaURL !== void 0 && (_ctaURL$match = _ctaURL.match) !== null && _ctaURL$match !== void 0 && _ctaURL$match.call(_ctaURL, /^https?:\/\//))) {
      ctaURL = '';
    }
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("ul", {
      className: (0, _classnames.default)(classes, 'rad-container')
    }, hasSection && /*#__PURE__*/_react.default.createElement(_text.default.li, {
      className: "rad-section-heading",
      text: section
    }), /*#__PURE__*/_react.default.createElement(_text.default.li, {
      className: "rad-title",
      text: title
    }), /*#__PURE__*/_react.default.createElement(_text.default.li, {
      className: "rad-content",
      text: message
    }), ctaURL && cta.text && /*#__PURE__*/_react.default.createElement("li", {
      className: "rad-link"
    }, /*#__PURE__*/_react.default.createElement("a", {
      href: ctaURL,
      target: "_self",
      "data-eid": eids && eids.click
    }, cta.text))));
  }

  /**
   * Renders static (no link) notification.
   *
   * @returns {React.ReactElement} Individual notification
   *
   * @params {Object} notification Single notification
   * @params {string} [notification.priority] level of priority EX: 'medium' or 'high'
   * @params {string} [notification.subcategory] Notification category EX:'FailedBilling'
   * @params {string} [notification.link] URl notification points to.
   * @params {array} classes List of needed classes
   * @params {Icon} icon Visual indicator type icon
   *
   * @private
   */

  renderStaticNotification(notification, classes, icon) {
    return /*#__PURE__*/_react.default.createElement("span", {
      className: (0, _classnames.default)(classes, 'no-link')
    }, icon, notification.content);
  }
  render() {
    const {
      notification,
      index
    } = this.props;
    const {
      priority,
      subcategory,
      link,
      eids = {}
    } = notification;
    if (eids.impression && eids.impression.includes('holdout')) {
      return null;
    }
    const type = subcategory === 'FailedBilling' ? 'creditCardExpiration' : '';
    const priorityClassMap = {
      Medium: 'medium',
      High: 'high'
    };
    const priorityClass = priorityClassMap[priority] || '';
    const priorityLabelClassName = (0, _classnames.default)('priority', priorityClass, type);
    const classes = [];
    const icon = type === 'creditCardExpiration' ? /*#__PURE__*/_react.default.createElement(_creditCard.default, null) : /*#__PURE__*/_react.default.createElement(_alert.default, null);
    let notifyBody;
    if (notification.isRad) {
      classes.push('notifications-rad-list-item');
      notifyBody = this.renderRADNotification(notification, priorityLabelClassName);
    } else if (link) {
      classes.push('notifications-list-item');
      notifyBody = this.renderNotificationLink(notification, link, priorityLabelClassName, icon);
    } else {
      classes.push('notifications-list-item');
      notifyBody = this.renderStaticNotification(notification, priorityLabelClassName, icon);
    }
    return /*#__PURE__*/_react.default.createElement("li", {
      className: (0, _classnames.default)(classes),
      id: `notifications-list-item-${index}`
    }, notifyBody, /*#__PURE__*/_react.default.createElement("div", {
      className: "notification-divider"
    }));
  }
}

/**
 * Property definitions.
 *
 * @type {Object}
 * @public
 *
 */

NotificationListItem.propTypes = {
  /**  User notifications */
  notification: _shapes.default.notification.isRequired,
  /** Order of individual notification */
  index: _propTypes.default.number
};
var _default = NotificationListItem;
exports.default = _default;